import { Icon } from '../../../Components'
import { cap } from '../../../State'
import { translations } from '../../../translations'
import { QuotesTypeElement } from './QuotesTypeElement'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

export const ServiceElement = ({ service: { icon, name, filters }, coefficient }) => (
  <div className="nsec">
    <div className="nsec__head">
      <div className="admin-coefficient-service-icon">
        <Icon name={icon} size={20} />
      </div>
      <div>
        <h3 className="nsec__title">
          {t.servizio} {name}:
        </h3>
        <div className="admin-coefficient-service-sub">
          {t.mxImpostaCoefficientiPer}
          {name}:
        </div>
      </div>
    </div>
    <div className="nsec__body admin-coefficient-service-body">
      {filters.map((filter, index) => (
        <div key={index} className="admin-coefficient-filter-card">
          <QuotesTypeElement coefficient={coefficient} filter={filter} />
        </div>
      ))}
    </div>
  </div>
)
